import React from 'react';
import { InView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';

interface OwnProps {
    tabHref: string;
    isScrolling: boolean;
    setSelectedTabCallback: (tabHref: string) => UnknownAction;
    onChange?: (inView: boolean) => void;
}

type Props = OwnProps;

// Adjust viewport to trigger inView when the component is 25% in view
// which is what customer actually seeing first on the screen
const VIEWPORT_ADJUST = '-25% 0% -75% 0%';

const DetailInViewWrapper: React.FC<React.PropsWithChildren<Props>> = (props) => {
    // InView with preset settings for detail page
    const dispatch = useDispatch();

    const onComponentInView = (inView: boolean) => {
        if (inView && !props.isScrolling) {
            dispatch(props.setSelectedTabCallback(props.tabHref));
            props.onChange && props.onChange(inView);
        }
    };

    return (
        <InView onChange={onComponentInView} delay={150} skip={props.isScrolling} rootMargin={VIEWPORT_ADJUST}>
            {props.children}
        </InView>
    );
};
DetailInViewWrapper.displayName = 'DetailInViewWrapper';

export default DetailInViewWrapper;
